import { createAsyncThunk } from '@reduxjs/toolkit';
import { processThunkError } from '@utils/processThunkError';
import { genericTokenCheck } from '@containers/App/state/thunks';

import SubscriptionPageAPIs, {
  getSubscriptionPricingType,
  getSubscriptionStatusType,
  orderSubscriptionType,
} from './apis';

export const orderSubscriptionThunk = createAsyncThunk(
  'subscriptionPage/orderSubscription',
  async (payload: orderSubscriptionType, { dispatch, rejectWithValue }) => {
    let results;
    try {
      const token = await genericTokenCheck(dispatch);
      results = await SubscriptionPageAPIs.orderSubscriptionAPI(token, payload);
    } catch (err: any) {
      const errorReject = await processThunkError(
        err,
        dispatch,
        'SUBSCRIPTION_PAGE',
      );
      return rejectWithValue(errorReject);
    }

    return results;
  },
);

export const getSubscriptionPricingThunk = createAsyncThunk(
  'subscriptionPage/getSubscriptionPricing',
  async (
    payload: getSubscriptionPricingType,
    { dispatch, rejectWithValue },
  ) => {
    let results;
    try {
      const token = await genericTokenCheck(dispatch);
      results = await SubscriptionPageAPIs.getSubscriptionPricingAPI(
        token,
        payload,
      );
    } catch (err: any) {
      const errorReject = await processThunkError(
        err,
        dispatch,
        'SUBSCRIPTION_PAGE',
      );
      return rejectWithValue(errorReject);
    }

    return results;
  },
);

export const getSubscriptionStatusThunk = createAsyncThunk(
  'subscriptionPage/getSubscriptionStatus',
  async (payload: getSubscriptionStatusType, { dispatch, rejectWithValue }) => {
    let results;
    try {
      const token = await genericTokenCheck(dispatch);
      results = await SubscriptionPageAPIs.getSubscriptionStatusAPI(
        token,
        payload,
      );
    } catch (err: any) {
      const errorReject = await processThunkError(
        err,
        dispatch,
        'SUBSCRIPTION_PAGE',
        true,
      );
      return rejectWithValue(errorReject);
    }

    return results;
  },
);
